import Box from "@mui/material/Box";

export const kbdSx = {
  fontFamily: "monospace",
  fontSize: "0.7rem",
  px: 0.5,
  mx: 0.25,
  bgcolor: "action.selected",
  borderRadius: 0.5,
} as const;

/** A key, as in shortcut hints ("P pursue"). */
export default function Kbd({ children }: { children: string }) {
  return (
    <Box component="kbd" sx={kbdSx}>
      {children}
    </Box>
  );
}
